import { render, staticRenderFns } from "./MyAccountsWdrwTab.vue?vue&type=template&id=b5a34c30"
import script from "./MyAccountsWdrwTab.vue?vue&type=script&lang=js"
export * from "./MyAccountsWdrwTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5a34c30')) {
      api.createRecord('b5a34c30', component.options)
    } else {
      api.reload('b5a34c30', component.options)
    }
    module.hot.accept("./MyAccountsWdrwTab.vue?vue&type=template&id=b5a34c30", function () {
      api.rerender('b5a34c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/accounts/MyAccountsWdrwTab.vue"
export default component.exports